EmailFormIntlBaseDateInputView = require "./base_date_input_view.coffee"
Backbone = require 'backbone'
Backbone.$ = $

class EmailFormIntlDateInputView extends EmailFormIntlBaseDateInputView
  tagName: 'li'

  events:
    'change .date_input'  : 'validateEmailForm'
    'keydown .date_input' : 'deleteKeyDownHandler'

  initialize: ->
    EmailFormIntlBaseDateInputView::initialize.apply(this, arguments)
    @elementID = ".date_input"
    @show_template = {date_input_template: true}


  readInput: ->
    @getInputHtmlElement().val().trim()

module.exports = EmailFormIntlDateInputView
